//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// FormAction
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export class FormAction {

    //Common fields
    field_display = "Link Display";
    field_name = "act_link_name"
    field_show = true;
    field_hover_text = "";
    field_type = "action";
    field_accesskey = null;

    field_validation = null;
    field_validation_msg = null;

    //Meta fields for controlling appearance
    __emphasize = false;
    __enabled = true;    
    __hidden = false;

    //Form field poperties not used for action links
    field_max = null;
    field_readOnly = false;
    field_required = false;

    //Form field poperties only used if sourced from DB
    field_id = null;
    field_order = 0; //Not needed when added manually as we can add them in the proper order


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    //Standard action link creation is three values, so let's add that to the constructor
    constructor(name, display, fieldShow, hoverText, accessKey){
        if (name) { this.field_name = name; }
        if (display) { this.field_display = display; }
        if (typeof fieldShow !== 'undefined') { this.field_show = !!fieldShow }
        if (hoverText) { this.field_hover_text = hoverText };
        if (accessKey) { this.field_accesskey = accessKey };
    };
}